import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Cart.css";

function Cart() {
  const [cartItems, setCartItems] = useState([]);
  const [subtotal, setSubtotal] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      sessionStorage.setItem("redirectAfterLogin", "/cart");
      navigate("/login");
    }

    const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCartItems(storedCart);
    calculateSubtotal(storedCart);
  }, []);

  const calculateSubtotal = (items) => {
    const total = items.reduce((sum, item) => sum + item.price * item.quantity, 0);
    setSubtotal(total);
  };

  const updateQuantity = (index, newQty) => {
    const updatedCart = [...cartItems];
    updatedCart[index].quantity = Number(newQty);
    setCartItems(updatedCart);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
    calculateSubtotal(updatedCart);
  };

  const removeItem = (index) => {
    const updatedCart = cartItems.filter((_, i) => i !== index);
    setCartItems(updatedCart);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
    calculateSubtotal(updatedCart);
  };

  return (
    <div className="cart-container">
      <h2 className="cart-heading">🛒 Your Shopping Cart</h2>

      {cartItems.length === 0 ? (
        <p className="empty-message">Your cart is empty.</p>
      ) : (
        <div className="cart-content">
          <div className="cart-items">
            {cartItems.map((item, index) => (
              <div className="cart-card" key={index}>
                <img
                  src={`https://kolibusiness.com/backend/uploads/${item.image}`}
                  alt={item.title}
                  className="cart-image"
                />
                <div className="cart-info">
                  <h3>{item.title}</h3>
                  <p className="price">₹{item.price}</p>

                  <button className="emi-btn">💳 EMI Options Available</button>

                  <label>Qty:</label>
                  <select
                    value={item.quantity}
                    onChange={(e) => updateQuantity(index, e.target.value)}
                  >
                    {[...Array(10).keys()].map((n) => (
                      <option key={n + 1} value={n + 1}>
                        {n + 1}
                      </option>
                    ))}
                  </select>

                  <div className="action-buttons">
                    <button onClick={() => removeItem(index)}>❌ Remove</button>
                    <button onClick={() => alert("Moved to wishlist")}>
                      ❤️ Move to Wishlist
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="cart-summary">
            <h3>🧾 Price Summary</h3>
            <p>Items: {cartItems.reduce((sum, item) => sum + item.quantity, 0)}</p>
            <p>Subtotal: ₹{subtotal.toFixed(2)}</p>
            <p>Delivery: <span className="free">Free</span></p>
            <hr />
            <h4>Total: ₹{subtotal.toFixed(2)}</h4>
            <button
              className="checkout-btn"
              onClick={() => navigate("/checkout")}
            >
              ✅ Proceed to Checkout
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Cart;
